import React from 'react';
import PropTypes from 'prop-types';

import EditInput from '../EditInput';

import { MultilineText } from './style';

const EditTextArea = ({
  children,
  classes,
  onChange,
  rows,
  rowsMax,
  value,
}) => (
  <div>
    <EditInput
      classes={classes}
      fullWidth
      multiline
      onChange={onChange}
      rows={rows}
      rowsMax={rowsMax}
      value={value}
    >
      <MultilineText>
        {children}
      </MultilineText>
    </EditInput>
  </div>
);

EditTextArea.propTypes = {
  children: PropTypes.node,
  classes : PropTypes.shape({}),
  rows    : PropTypes.number,
  rowsMax : PropTypes.number,
  onChange: PropTypes.func,
  value   : PropTypes.string,
};
EditTextArea.defaultProps = {
  children: null,
  rows    : 2,
  rowsMax : 5,
  onChange: () => {},
  value   : '',
  classes : {},
};

export default EditTextArea;
